<template>
  <div id="loginManage">
    <div class="login-box">
      <div class="login-content">
        <div class="content-title">自嗨启动器后台管理系统</div>
        <el-form ref="form" :model="form" label-width="0px">
          <el-form-item label="">
            <el-input placeholder="手机号" v-model="form.phoneNum">
              <template slot="prepend"><i class="el-icon-user"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input type="password" placeholder="密码" v-model="form.password">
              <template slot="prepend"><i class="el-icon-lock"></i></template>
            </el-input>
          </el-form-item>
<!--          <el-form-item label="">-->
<!--            <div style="display: flex;justify-content: space-between">-->
<!--              <el-input placeholder="验证码" v-model="form.verity">-->
<!--                <template slot="prepend"><i class="el-icon-magic-stick"></i></template>-->
<!--              </el-input>-->
<!--              <img :src="baseUrl + '/login/captcha'" @click="refreshVerity" ref="verityImg"/>-->
<!--            </div>-->
<!--          </el-form-item>-->
          <label style="float: left;color: #a8a8a8;margin-bottom: 25px">如果忘记密码，请联系系统管理员！</label>
          <el-form-item>
            <el-button type="primary" style="width: 100%" @click="login()">登录</el-button>
          </el-form-item>
        </el-form>
        <!--<div style="text-align: center;width: 100%;margin-top: 25px;color: #333333;cursor: pointer"-->
        <!--@click="register">注册-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {matchPassword} from "@/utils/common";
import md5 from "js-md5";
import {getBaseUrl} from "@/utils/request";

export default {
  name: "login",
  data() {
    return {
      baseUrl: getBaseUrl(),
      form: {
        phoneNum: '',
        password: '',
      },
    }
  },
  mounted() {
  },
  methods: {
    login() {
      // if (matchPassword(this.form.password)) {
        let _form = JSON.parse(JSON.stringify(this.form));
        this.$store.dispatch('user/login', _form).then(() => {
          this.$router.push('/userManage');
        }).catch(() => {
        })
      // } else {
      //   this.$message.warning("密码首位字母，且必须包含大小写字母，数字和特殊字符")
      // }

    }
  }
}
</script>

<style scoped lang="scss">
#loginManage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/image/manage-bg.jpg") no-repeat;
  background-size: cover;
  overflow-y: auto;

  .login-box {
    width: 400px;
    margin: 250px auto 0 auto;
    height: 500px;
    /*display: flex;*/
  }

  .login-title {
    flex: 1;
    background: #6486aa4d;

    .login-logo {
      font-size: 40px;
      color: #ffffff;
      font-weight: bold;
      margin-bottom: 30px;
      margin-top: 150px;
      margin-left: 210px;
    }

    .title-name {
      font-size: 36px;
      color: #ffffff;
      /*text-align: center;*/
      margin-left: 210px;
    }
  }

  .login-content {
    width: 400px;
    height: auto;
    padding: 80px 60px;
    background: #FFFFFF;
    border-radius: 3px;

    img {
      width: 100px;
      margin-left: 15px;
    }
  }

  .content-title {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    color: var(--color-primary);
    margin-bottom: 60px;
  }

}
</style>
